import { render, staticRenderFns } from "./DashboardByIframe.vue?vue&type=template&id=2ce8da0e"
import script from "./DashboardByIframe.vue?vue&type=script&lang=js"
export * from "./DashboardByIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports